/*
  SCAFF24 CRO-Filterspalte (Handoff "Kategorieseite Layher Gerueste").
  Ohne Framework, ohne Abhaengigkeiten.

  Drei Bausteine:
  1. Von/Bis-Regler auf INDIZES der vorhandenen Maße. Die Handles koennen
     damit nur echte Katalogwerte anfahren, Zwischenwerte gibt es im Layher-
     Feldraster nicht.
  2. Schnellauswahl-Pills (bis 10 m / 10-20 m / ueber 20 m).
  3. Aufklappbare Gruppen und der mobile Drawer.

  Angewendet wird ueber window.scaffAjaxApplyUrl aus custom.js: dieselbe
  Section-Rendering-Logik, die auch die Filter-Badges nutzen. Der Handoff
  schlaegt form.requestSubmit() vor, das waere ein voller Seiten-Reload -
  genau das war die Kundenanforderung, die wir vorher abgeschafft haben.
  Faellt die Funktion aus, wird normal navigiert.
*/
(function () {
  'use strict';

  function deNum(n, unit) {
    var s = n.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return unit ? s + ' ' + unit : s;
  }

  function apply(url, ref, opts) {
    if (typeof window.scaffAjaxApplyUrl === 'function') {
      window.scaffAjaxApplyUrl(new URL(url, window.location.href), ref, null, opts || null);
    } else {
      window.location.href = url;
    }
  }

  // Welcher Regler wird gerade gezogen. Modulweit, damit EIN window-Listener
  // fuer das Loslassen genuegt. Pro Regler wuerde sich mit jedem
  // Section-Tausch ein weiterer Listener auf einem abgehaengten Knoten
  // ansammeln. window statt Element, weil man die Maus beim Ziehen auch
  // ausserhalb des Reglers loslassen kann.
  var aktiverZug = null;
  function zugBeenden() { if (aktiverZug) aktiverZug(); }
  window.addEventListener('pointerup', zugBeenden);
  window.addEventListener('pointercancel', zugBeenden);

  /* ---------- Regler ---------- */
  function initRange(root, scope) {
    if (root.dataset.scaffRangeBound) return;
    root.dataset.scaffRangeBound = '1';

    var unit = root.dataset.unit || '';
    var nodes = [].slice.call(root.querySelectorAll('[data-scaff-range-value]'));

    // Numerisch sortieren. Der Handoff nutzt Liquids `sort: 'value'`, das
    // sortiert als TEXT und wuerde "9.5" hinter "49.4" einordnen.
    var items = nodes
      .map(function (n) {
        return {
          raw: n.dataset.scaffRangeValue,
          num: parseFloat(String(n.dataset.scaffRangeValue).replace(',', '.')),
          count: parseInt(n.dataset.scaffRangeCount, 10) || 0,
          active: n.dataset.scaffRangeActive === '1',
          add: n.dataset.scaffRangeAdd || ''
        };
      })
      .filter(function (i) { return !isNaN(i.num); })
      .sort(function (a, b) { return a.num - b.num; });

    if (items.length < 2) { root.hidden = true; return; }

    var lo = root.querySelector('[data-scaff-range-handle="min"]');
    var hi = root.querySelector('[data-scaff-range-handle="max"]');
    var outLo = root.querySelector('[data-scaff-range-out="min"]');
    var outHi = root.querySelector('[data-scaff-range-out="max"]');
    var sum = scope ? scope.querySelector('[data-scaff-group-sum]') : null;
    var last = items.length - 1;

    [lo, hi].forEach(function (h) { h.min = 0; h.max = last; });

    // Startzustand aus der URL: erster und letzter aktive Wert
    var activeIdx = items.reduce(function (acc, it, i) { if (it.active) acc.push(i); return acc; }, []);
    var startLo = activeIdx.length ? activeIdx[0] : 0;
    var startHi = activeIdx.length ? activeIdx[activeIdx.length - 1] : last;
    lo.value = startLo;
    hi.value = startHi;

    // param_name kommt direkt aus Liquid (filter.param_name). Ihn aus einer
    // url_to_add zu parsen waere falsch: sobald eine ANDERE Gruppe aktiv ist,
    // stehen in dieser URL mehrere filter.p.*-Parameter und man erwischt den
    // erstbesten statt den eigenen.
    var paramName = root.dataset.param || null;

    function paint() {
      var a = +lo.value, b = +hi.value;
      outLo.textContent = deNum(items[a].num, unit);
      outHi.textContent = deNum(items[b].num, unit);
      if (sum) {
        sum.textContent = (a === 0 && b === last)
          ? 'alle Maße'
          : deNum(items[a].num, '') + ' – ' + deNum(items[b].num, unit);
      }
      root.querySelectorAll('[data-scaff-range-preset]').forEach(function (btn) {
        var p = btn.dataset.scaffRangePreset.split(',').map(Number);
        var idx = groupIdx(p[0], p[1]);
        var on = idx.length && a === idx[0] && b === idx[idx.length - 1];
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    function groupIdx(from, to) {
      return items.reduce(function (acc, it, i) {
        if (it.num > from && it.num <= to) acc.push(i);
        return acc;
      }, []);
    }

    // Mit dem Startzustand vorbelegen. Sonst gilt die Spanne, die beim Laden
    // schon in der URL steht, als "noch nicht angewendet": zieht man einmal weg
    // und wieder zurueck, geht eine voellig identische Anfrage raus. Nach dem
    // AJAX-Tausch ist das derselbe Fall, weil die Bindung neu aufgebaut wird.
    var lastApplied = startLo + ':' + startHi;
    var zieht = false;
    var teilGetauscht = false;

    function commit(force) {
      if (!paramName) return;
      var a = +lo.value, b = +hi.value;
      // Gleiche Spanne nicht erneut anwenden: beim Ziehen ueber mehrere
      // Rasterwerte hinweg landet man sonst zweimal auf demselben Stand.
      var stamp = a + ':' + b;
      if (!force && stamp === lastApplied) return;
      lastApplied = stamp;
      var url = new URL(window.location.href);
      url.searchParams.delete(paramName);
      if (!(a === 0 && b === last)) {
        for (var i = a; i <= b; i++) url.searchParams.append(paramName, items[i].raw);
      }
      url.searchParams.delete('page');

      if (zieht) {
        // Waehrend man den Regler festhaelt wird NUR das Raster getauscht.
        // Wuerde die ganze Section ersetzt, verschwindet der Regler unter dem
        // Finger: der Knoten ist weg, der Zug reisst ab und der Griff bleibt
        // stehen. Genau das fuehlt sich wie "haengt" an. Die Filterspalte
        // bleibt deshalb derselbe DOM-Knoten.
        // replaceState statt pushState, sonst braucht man nach einem einzigen
        // Zug ein Dutzend Mal "zurueck". Und ohne Ladeschleier, der wuerde bei
        // jedem Zwischenschritt aufblitzen.
        teilGetauscht = true;
        apply(url.toString(), root, {
          partial: '.productgrid--wrapper',
          replaceState: true,
          quiet: true
        });
        beruhigen();
      } else {
        teilGetauscht = false;
        apply(url.toString(), root, null);
      }
    }

    // Der Prototyp filtert schon beim Ziehen. Serverseitig geht das nicht pro
    // Pixel: jedes input-Event waere eine Anfrage. Deshalb entprellt - waehrend
    // des Ziehens laeuft die Anzeige sofort mit, das Raster folgt kurz darauf.
    // Waehrend eines Zugs kuerzer, damit es mitlaeuft; ueberholende Antworten
    // faengt der Sequenzzaehler in custom.js ab.
    var liveTimer = null;
    function commitSoon() {
      if (liveTimer) clearTimeout(liveTimer);
      liveTimer = setTimeout(function () {
        liveTimer = null;
        commit(false);
      }, zieht ? 180 : 320);
    }

    [lo, hi].forEach(function (h) {
      h.addEventListener('pointerdown', function () {
        zieht = true;
        aktiverZug = zugEnde;
      });
    });

    // Sicherheitsnetz. Kommt das Loslassen nicht an - Zeigerereignis
    // verschluckt, Maus ausserhalb des Fensters losgelassen, Geste vom System
    // abgebrochen - bliebe die Seite sonst dauerhaft auf dem Teil-Stand stehen
    // und der abschliessende vollstaendige Tausch kaeme nie.
    var settleTimer = null;
    function beruhigen() {
      if (settleTimer) clearTimeout(settleTimer);
      settleTimer = setTimeout(function () {
        settleTimer = null;
        if (!teilGetauscht) return;
        zieht = false;
        aktiverZug = null;
        commit(true);
        teilGetauscht = false;
      }, 900);
    }

    function zugEnde() {
      aktiverZug = null;
      if (!zieht) return;
      zieht = false;
      if (settleTimer) { clearTimeout(settleTimer); settleTimer = null; }
      if (liveTimer) { clearTimeout(liveTimer); liveTimer = null; }
      // Zum Abschluss die ganze Section, damit die Zahlen neben den uebrigen
      // Optionen und die Chips wieder stimmen. force, weil die Spanne seit dem
      // letzten Teil-Tausch unveraendert sein kann - ohne force wuerde die
      // Bremse oben den Abschluss verschlucken.
      commit(teilGetauscht);
      teilGetauscht = false;
    }

    lo.addEventListener('input', function () {
      if (+lo.value > +hi.value) lo.value = hi.value;   // Handles kreuzen nicht
      paint();
      commitSoon();
    });
    hi.addEventListener('input', function () {
      if (+hi.value < +lo.value) hi.value = lo.value;
      paint();
      commitSoon();
    });

    // change bleibt entprellt. Ein input[type=range] feuert bei Pfeiltasten pro
    // Druck input UND change, bei gehaltener Taste also gut 30 mal in der
    // Sekunde; haengt man hier ein sofortiges Anwenden dran, wird daraus eine
    // Anfrage pro Tastendruck. Der Maus-Weg braucht das nicht: dort schliesst
    // zugEnde den Zug beim Loslassen sofort ab.
    lo.addEventListener('change', commitSoon);
    hi.addEventListener('change', commitSoon);

    root.querySelectorAll('[data-scaff-range-preset]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var p = btn.dataset.scaffRangePreset.split(',').map(Number);
        var idx = groupIdx(p[0], p[1]);
        var schonAktiv = idx.length && +lo.value === idx[0] && +hi.value === idx[idx.length - 1];
        if (schonAktiv || !idx.length) {          // Klick auf die aktive Pill = zurueck auf alles
          lo.value = 0; hi.value = last;
        } else {
          lo.value = idx[0]; hi.value = idx[idx.length - 1];
        }
        paint();
        commit(false);
      });
    });

    paint();
  }

  /* ---------- Gruppen, Facet-Links, Drawer ---------- */
  function init(scopeRoot) {
    var root = scopeRoot || document;

    root.querySelectorAll('[data-scaff-group]').forEach(function (grp) {
      var body = grp.querySelector('[data-scaff-group-body]');
      var range = grp.querySelector('[data-scaff-range]');
      if (range) initRange(range, grp);

      var toggle = grp.querySelector('[data-scaff-group-toggle]');
      if (!toggle || toggle.dataset.scaffBound) return;
      toggle.dataset.scaffBound = '1';
      toggle.addEventListener('click', function () {
        var open = grp.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        void body;
      });
    });

    // Zusammenfassung je Checkbox-/Pill-Gruppe: Anzahl aktiver Werte
    root.querySelectorAll('[data-scaff-group]').forEach(function (grp) {
      if (grp.querySelector('[data-scaff-range]')) return;
      var sum = grp.querySelector('[data-scaff-group-sum]');
      if (!sum) return;
      var n = grp.querySelectorAll('[data-scaff-facet-link][aria-pressed="true"]').length;
      sum.textContent = n ? n + ' aktiv' : '';
    });
  }

  // Facet-Links (Karten, Pills, Checkboxen) ohne sichtbaren Reload anwenden.
  // Capture-Phase, damit der native Empire-Handler nicht auch noch navigiert.
  document.addEventListener('click', function (ev) {
    var link = ev.target.closest('.scaff-facets [data-scaff-facet-link], .scaff-facets [data-scaff-facets-reset]');
    if (!link) return;
    var href = link.getAttribute('href');
    if (!href) return;
    ev.preventDefault();
    ev.stopPropagation();
    apply(href, link);
  }, true);

  // Preisfelder: Formular abfangen und als URL anwenden
  document.addEventListener('submit', function (ev) {
    var form = ev.target.closest('[data-scaff-price]');
    if (!form) return;
    ev.preventDefault();
    var url = new URL(window.location.href);
    [].slice.call(form.querySelectorAll('input[name]')).forEach(function (inp) {
      url.searchParams.delete(inp.name);
      if (inp.value !== '') url.searchParams.set(inp.name, inp.value);
    });
    url.searchParams.delete('page');
    apply(url.toString(), form);
  });

  /* ---------- Drawer ---------- */
  var drawerOpen = false;
  function drawer(open) {
    var panel = document.querySelector('[data-scaff-facets]');
    var scrim = document.querySelector('[data-scaff-scrim]');
    if (!panel) return;
    drawerOpen = !!open;
    panel.classList.toggle('is-open', drawerOpen);
    if (scrim) scrim.hidden = !drawerOpen;
    document.body.classList.toggle('scaff-facets-lock', drawerOpen);
  }

  document.addEventListener('click', function (ev) {
    if (ev.target.closest('[data-productgrid-trigger-filters]')) {
      // Nur wenn die CRO-Spalte auf der Seite ist, sonst nativen Handler lassen
      if (document.querySelector('[data-scaff-facets]')) {
        ev.preventDefault();
        ev.stopPropagation();
        drawer(true);
      }
      return;
    }
    if (ev.target.closest('[data-scaff-facets-close]') || ev.target.closest('[data-scaff-scrim]')) {
      drawer(false);
    }
  }, true);

  document.addEventListener('keydown', function (ev) {
    if (ev.key === 'Escape') drawer(false);
  });

  /* ---------- Zustand ueber den Section-Tausch retten ----------
     Beim Filtern wird die ganze Section ersetzt, also auch die Filterspalte.
     Ohne das Folgende passiert dreierlei: der mobile Drawer klappt zu (und
     zwar bei JEDEM Zug am Regler, seit live gefiltert wird), die Filterspalte
     springt nach oben, und die Tastaturbedienung verliert den Griff. */
  var keep = null;

  function stash() {
    var scroller = document.querySelector('.scaff-facets__scroll');
    var focused = document.activeElement;
    var handle = null;
    if (focused && focused.dataset && focused.dataset.scaffRangeHandle) {
      var box = focused.closest('[data-scaff-range]');
      handle = {
        param: box ? box.dataset.param : null,
        side: focused.dataset.scaffRangeHandle
      };
    }
    keep = {
      open: drawerOpen,
      scrollTop: scroller ? scroller.scrollTop : 0,
      handle: handle
    };
  }

  function restore() {
    if (!keep) return;
    var scroller = document.querySelector('.scaff-facets__scroll');
    if (scroller && keep.scrollTop) scroller.scrollTop = keep.scrollTop;
    drawer(keep.open);
    if (keep.handle && keep.handle.param) {
      var box = document.querySelector('[data-scaff-range][data-param="' + keep.handle.param + '"]');
      var input = box && box.querySelector('[data-scaff-range-handle="' + keep.handle.side + '"]');
      if (input) input.focus({ preventScroll: true });
    }
    keep = null;
  }

  document.addEventListener('shopify:section:unload', stash, true);

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  // Nach dem AJAX-Section-Tausch neu binden
  document.addEventListener('shopify:section:load', function (ev) {
    init(ev.target && ev.target.querySelectorAll ? ev.target : document);
    restore();
  });
  if (document.readyState !== 'loading') init(document);
})();
